
export default {
  computed: {
    budgets () {
      return this.$store.getters['BudgetsStore/budgets'] || []
    },
    currentPage () {
      return this.$store.getters['BudgetsStore/currentPage']
    },
    lastPage () {
      return this.$store.getters['BudgetsStore/lastPage']
    },
    isCallingBudgets () {
      return this.$store.getters['BudgetsStore/isCallingBudgets']
    }
  },
  methods: {
    nextPage () {
      this.$store.dispatch('BudgetsStore/nextBudgetsPage')
    },
    paginationHandler () {
      window.onscroll = () => {
        let bottomOfWindow = (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight

        if (bottomOfWindow && this.currentPage < this.lastPage) {
           this.nextPage()
        }
      }
    }
  },
  mounted () {
    this.paginationHandler()
  }
}
